module.exports = __webpack_public_path__ + "765a3a6f91f544ec3fb9f16c462f3cfb.png";